<template>
  <tr class="lb-row">
    <td>
      {{ rank }}.
      <a v-if="url" class="gg-branding-supporting" :href="url" target="_blank"> {{this.entryName}}</a>
      <span v-else> {{this.entryName}}</span>
      <small v-if="fundableTitle" class="d-block ml-4">
        <a class="gg-branding-supporting" :href="fundableUrl" target="_blank">
          ({{this.fundable_profile.title}})
        </a>
      </small>
      <small v-if="revealLocation" class="text-muted"> ({{address.city}}, {{address.state}})</small>
    </td>
    <td v-for="(value, name) in result.leaderboard_columns" :key="name">
      <ICountUp
        :endVal="formattedValue(name, value)"
        :options="countOptions(name, value)"
      />
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import ICountUp from 'vue-countup-v2';

export default {
  name: 'LeaderboardRow',
  components: {
    ICountUp
  },
  props: {
    entryIndex: Number,
    result: Object,
  },
  data () {
    return {
      dollarColumns: [
        'amount_raised', 'dollars_percent_of_total_pool', 'donors_percent_of_total_pool',
        'gift_percent_diff_positive_pool', 'gift_percent_of_total_pool', 'patterson_donor_gifts',
        'patterson_match_and_prizes', 'patterson_total_raised', 'previous_totals',
        'ranked_bonus_total_amount_raised', 'ranked_bonus_total_donations_count',
        'sum_amounts_match_donations_incentives', 'sum_amounts_match_incentives'
      ],
      percentColumns: [
        'dollars_percent', 'dollars_percent_of_total', 'donors_percent', 'donors_percent_diff',
        'donors_percent_of_total', 'employees_percent', 'gift_percent', 'gift_percent_diff',
        'gift_percent_of_total'
      ],
      entryName: null,
      firstRender: true,
      fundableTitle: null,
      fundableUrl: null,
      revealLocation: false,
      url: null,
    }
  },
  computed: {
    ...mapGetters(['custom']),
    rank () { return this.entryIndex + 1 },
  },
  mounted () {
    this.firstRender = false;
    const type = this.$parent.$parent.lb.leaderboard_type;
    if (['groups', 'reg_survey_filtered', 'registration_type_filtered', 'umbrella_dog'].includes(type)) {
      this.entryName = this.result.measurable.group.name;
      this.url = `${this.$store.state.dog.url}/organizations/${this.result.measurable.group.slug}`;
    } else if (type === 'business_fundraisers') {
      this.entryName = this.result.measurable.name;
      this.url = `${this.$store.state.dog.url}/business_fundraisers/${this.result.measurable.slug}`;
    } else if (type === 'donor_survey_question') {
      this.entryName = this.result.measurable.body;
    } else if (type === 'p2p_fundraisers') {
      this.entryName = this.result.measurable.name;
      this.url = `${this.$store.state.dog.url}/p2p/${this.result.measurable.id}/${this.result.measurable.user_slug}`;
      if (this.custom('reveal_fundable_name_in_p2p_lbs')) {
        this.fundableUrl = this.result.fundable_profile.url;
        this.fundableTitle = this.result.fundable_profile.title;
      }
    }
  },
  methods: {
    formattedValue (calcType, value) {
      return this.dollarColumns.includes(calcType) ? Math.round(value / 100) : value;
    },
    countOptions (calcType, value) {
      const opts = {};
      if (this.dollarColumns.includes(calcType)) { opts.prefix = '$' }
      else if (this.percentColumns.includes(calcType)) {
        opts.decimalPlaces = this.custom('leaderboard_percent_decimal_places');
        opts.suffix = '%';
      }
      if (this.firstRender) { opts.startVal = this.formattedValue(calcType, value) }
      return opts;
    },
  }
}
</script>

<style scoped lang="scss">
td:first-child {
  text-align: left;
}
@media screen and (min-width: 768px) {
  td:first-child {
    /* LB entries are truncated w ellipses instead of wrapping https://css-tricks.com/line-clampin/ */
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
}
</style>
